
<template>
  <div class="sub-text" :style="style">
      <slot></slot>                
  </div>
</template>

<script>
export default {

    name: 'UiText',

    props: {
      align: {
        type: String,
        default: 'left'
      }
    },

    computed: {
      style () {
        return {
          '--align': this.align
        }
      }
    },
}
</script>

<style>
  .sub-text{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight:  400;
    font-size: 12px;
    line-height: 131.5%;
    color: gray;
    text-align: var(--align);
  }
   @media (max-width: 850px) {
    .sub-text{
      font-size: 10px;
    }
   }
</style>



// WEBPACK FOOTER //
// UISubText.vue?4ad08fa9